import { useTranslation } from "react-i18next";
import DateField from "../../field/DateField/DateField";
import { Grid } from "@mui/material";
import DateService from "../../../services/dateService";


export const DateRangeFilter = (props) => {
    const { searchParams, setSearchParams, filterName, labelFrom, labelTo } = props;
    const { t } = useTranslation();

    const handleChange = (event) => {
        const newSearchParams = new URLSearchParams(searchParams.toString());
        if (event.target.value) {
            newSearchParams.set(event.target.name,  DateService.convertDateToFormatYYYYMMDD(event.target.value));
        } else {
            // None - remove the filter
            newSearchParams.delete(event.target.name);
        }
        setSearchParams(newSearchParams);
    };

    return <Grid
        item
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
    >
        <DateField
            name={`${filterName}_after`}
            label={labelFrom || t("from")}
            value={searchParams.get(`${filterName}_after`)}
            onChange={handleChange}
        />
        <div style={{ marginInline: "5px" }}>{"-"}</div>
        <DateField
            name={`${filterName}_before`}
            label={labelTo || t("to")}
            value={searchParams.get(`${filterName}_before`)}
            onChange={handleChange}
        />
    </Grid>
};








 